import { Button } from 'antd';
import { withRbac } from '..';
export var RbacButton = withRbac(Button);
export default RbacButton;